import { FONTS } from '../../../config/app-config';
// src/components/navigation/header/LanguageSelector.js
import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const languageMapping = {
    en: 'English',
    de: 'German',
    es: 'Spanish',
    fr: 'French',
    it: 'Italian',
    ja: 'Japanese',
    ko: 'Korean',
};

function LanguageSelector({
                              options = [],            // Array von Codes, z.B. ['de','en']
                              selectedRelease,
                              setSelectedRelease,
                          }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [tipOpen, setTipOpen]   = useState(false);
    const menuOpen = Boolean(anchorEl);

    const handleOpen = (e) => {
        if (selectedRelease.product === 'supervisor' ? options.length > 0 : true) {
            setAnchorEl(e.currentTarget);
        }
    };
    const handleClose = () => setAnchorEl(null);

    // Regel: nur supervisor darf alle Sprachen wählen
    const availableLanguages =
        selectedRelease.product === 'supervisor'
            ? options
            : ['en'];

    // Fallback-Label
    const label = languageMapping[selectedRelease.language]
        || selectedRelease.language
        || 'Select Language';

    return (
        <>
            <Tooltip
                title="Choose Language"
                placement="bottom"
                open={tipOpen && !menuOpen}
                onOpen={() => setTipOpen(true)}
                onClose={() => setTipOpen(false)}
                disableFocusListener
                disableTouchListener
            >
                <Box
                    component="button"
                    type="button"
                    aria-label={`Choose Language: ${label}`}
                    onClick={(e) => { setTipOpen(false); handleOpen(e); }}
                    aria-haspopup="menu"
                    aria-expanded={menuOpen ? 'true' : undefined}
                    sx={{
                        color: 'inherit',
                        font: 'inherit',
                        background: 'transparent',
                        border: 0,
                        p: 0,
                        minWidth: { xs: 44, sm: 0 },
                        minHeight: { xs: 44, sm: 0 },
                        justifyContent: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: availableLanguages.length ? 'pointer' : 'default',
                        gap: 0.5
                    }}
                >
                    <LanguageIcon />
                    <Typography
                        variant="caption"
                        sx={{
                            display: { xs: 'none', lg: 'block' },
                            fontFamily: FONTS.body,
                            fontSize: '1rem',
                        }}
                    >
                        {label}
                    </Typography>
                    <ArrowDropDownIcon fontSize="small" />
                </Box>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
                {availableLanguages.length === 0 && (
                    <MenuItem disabled sx={{ fontFamily: FONTS.body }}>
                        Error loading Languages
                    </MenuItem>
                )}
                {availableLanguages.map((lang) => (
                    <MenuItem
                        key={lang}
                        onClick={() => {
                            setSelectedRelease(selectedRelease.with({ language: lang }));
                            handleClose();
                        }}
                        sx={{ fontFamily: FONTS.body }}
                    >
                        {languageMapping[lang] || lang}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default LanguageSelector;

